document.addEventListener('alpine:init', () => {
  Alpine.store('vimeoPopup', {
    video: null,
    container: null,
    content: null,

    init() {
      this.container = document.getElementById('vimeo-popup-container');
      this.content = document.getElementById('vimeo-popup-content');
    },

    open(id, width, height) {
      const match = id.match(/([0-9]+)(?:\/([0-9a-z]+)|$)?/i);

      if (!match) {
        return;
      }

      const m1 = match[1];
      const m2 = match[2] ? `h=${match[2]}&` : '';
      this.container.style.aspectRatio = `${width} / ${height}`;
      this.content.innerHTML = `<iframe title="PPRO video" src="https://player.vimeo.com/video/${m1}?${m2}autoplay=1&title=0&byline=0&portrait=0&muted=false" width="${width}" height="${height}" style="width: 100%; height: auto; aspect-ratio: ${width} / ${height}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
      this.video = { id, width, height };
    },

    close() {
      if (this.video) {
        this.video = null;
        setTimeout(() => {
          this.content.innerHTML = '';
        }, 500);
      }
    },
  });
});